/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['select-groups-modal{display:block}select-groups-modal .groups{text-transform:capitalize}select-groups-modal .groups>.group{margin-bottom:7px}select-groups-modal .groups>.group.disabled{opacity:.5;cursor:not-allowed}select-groups-modal .groups>.group.disabled>input,select-groups-modal .groups>.group.disabled>label{pointer-events:none}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvdXNlci9zZWxlY3QtZ3JvdXBzLW1vZGFsL3NlbGVjdC1ncm91cHMtbW9kYWwuY29tcG9uZW50LnNjc3MubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvdXNlci9zZWxlY3QtZ3JvdXBzLW1vZGFsL3NlbGVjdC1ncm91cHMtbW9kYWwuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// /mnt/e/apps/helpdesk/client/src/$$_gendir/app/user/select-groups-modal/select-groups-modal.component.scss.ngstyle.ts